import localize from '@/core/shared/localization';
import localizeMoment from '@/core/shared/localization/moment';

const i18n = localize(window.sbvrenv.BROWSER_LOCALE, 'developer-panel');
localizeMoment(window.sbvrenv.BROWSER_LOCALE);
export default i18n;
